import { useAuthStore } from '@/stores/auth'

let menusRefreshing: Promise<void> | null = null

async function ensureSession() {
  const auth = useAuthStore()
  if (!auth.token) {
    auth.restoreSession()
  }
  if (!auth.token) return false
  // 每次进受保护页刷新一次菜单，保证 RBAC 改权限后无需清缓存即可生效
  if (!menusRefreshing) {
    menusRefreshing = auth.refreshMenus().finally(() => {
      menusRefreshing = null
    })
  }
  await menusRefreshing
  return true
}

export const authGuard = async (to: any) => {
  const code = to.meta?.code
  if (!code || code === 'public') return true
  const auth = useAuthStore()
  const ok = await ensureSession()
  if (!ok) return { path: '/admin/login', query: { redirect: to.fullPath } }
  return auth.hasMenu(code) ? true : { path: '/admin/dashboard' }
}

export const mfaGuard = async (to: any) => {
  const code = to.meta?.code
  if (!code || code === 'public') return true
  const auth = useAuthStore()
  const ok = await ensureSession()
  if (!ok) return { path: '/admin/login' }
  return auth.mfaOK ? true : { path: '/admin/login' }
}
